export const LOGIN_AJAX_SUCCESS = "LOGIN_AJAX_SUCCESS";
export const LOGIN_SET_RETURNURL = "LOGIN_SET_RETURNURL";
export const ADMINISTRATOR = "Administrator";
export const SOAPBOX = "Soapbox";
export const AUTHOR = "Author";
export const SITECOORDINATOR = "SiteCoordinator";
export const ALLOWED_ROLES = [ADMINISTRATOR, SOAPBOX, AUTHOR, SITECOORDINATOR];